<template>
  <div class="tool-options-wrapper">
    <div
      v-for="option in optionList"
      :key="option.id"
      class="tool-option"
      @click="selectOption(option)"
    >
      <span>
        {{ option.name }}
      </span>
      <span
        v-if="isDisableSelect"
        v-tooltip="{
          content:
            '<span>You can select up to</span><br/><span>six info tools.</span>',
        }"
        class="disable-select"
        :class="{ 'show-hover-effect': !isNarrowWidthDevice }"
      >
        {{ $t('comparisonFeature.tools.selectionAddBtn') }}
      </span>
      <span
        v-if="!isDisableSelect"
        :class="{ 'show-hover-effect': !isNarrowWidthDevice }"
      >
        {{ $t('comparisonFeature.tools.selectionAddBtn') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import TOOLS, { TOOL_TYPE } from '../../constants/tools';
import { RESOURCE_LIST_STATUS } from '../../utils/validateInternetNumberResource';

export default {
  data() {
    return {
      tools: {},
    };
  },

  computed: {
    ...mapState([
      'comparisonToolCategory',
      'comparisonToolList',
      'comparisonToolQuery',
      'isNarrowWidthDevice',
    ]),
    ...mapGetters(['comparisonResourceListStatus']),

    optionList() {
      let optionList = this.tools[this.comparisonToolCategory];

      let optionListWithoutSelected = [];

      if (optionList) {
        // Show tools according to the Internet number resource added in Step1, e.g. if all the resources are AS, the prefix tools won't be shown in the list
        optionList = optionList.filter((option) => {
          // If this tool is for both prefix and AS, it should be shown
          if (option.type === TOOL_TYPE.PREFIX_AND_AS) return true;

          // If this tool is only for prefix, it should be shown when resource list contains prefix
          if (
            option.type === TOOL_TYPE.PREFIX &&
            (this.comparisonResourceListStatus ===
              RESOURCE_LIST_STATUS.PREFIX_ONLY ||
              this.comparisonResourceListStatus ===
                RESOURCE_LIST_STATUS.PREFIX_AND_AS)
          )
            return true;

          // If this tool is only for AS, it should be shown when resource list contains AS
          if (
            option.type === TOOL_TYPE.AS &&
            (this.comparisonResourceListStatus ===
              RESOURCE_LIST_STATUS.AS_ONLY ||
              this.comparisonResourceListStatus ===
                RESOURCE_LIST_STATUS.PREFIX_AND_AS)
          )
            return true;

          return false;
        });

        // remove selected option from optionList
        optionListWithoutSelected = optionList.filter((item) => {
          let isSelected = false;
          this.comparisonToolList.forEach((selectedTool) => {
            if (item.name === selectedTool.name) isSelected = true;
          });

          return !isSelected;
        });
      }

      // when comparisonToolQuery is empty, return directly
      if (!this.comparisonToolQuery) {
        return optionListWithoutSelected;
      } else {
        const list = [];

        // split tool query, e.g. "prefix count" will be separated as ['prefix', 'count']
        const splitToolQueryArray = this.comparisonToolQuery.split(' ');

        // do exact search first, e.g. search tools match "prefix count"
        const optionListFilteredByToolQuery = optionListWithoutSelected.filter(
          (item) => item.name.match(new RegExp(this.comparisonToolQuery, 'i'))
        );

        // push exact search resluts on the top of list, which means show them on the top
        if (optionListFilteredByToolQuery.length)
          list.push(...optionListFilteredByToolQuery);

        // loop the whole option list to do fuzzy search after exact search, e.g. search tools match "prefix" or "count"
        for (let i = 0; i < optionListWithoutSelected.length; i++) {
          // check if option has been added to list already by using findIndex
          const indexInList = list.findIndex(
            (item) => item.name === optionListWithoutSelected[i].name
          );

          // if option has been added (e.g. tool of "prefix count" has been added in list), jump over this option in the loop
          if (indexInList > -1) continue;

          // loop the array of split tool query to match with current option
          for (let j = 0; j < splitToolQueryArray.length; j++) {
            // check if the split tool query matches current option
            const isMatch = optionListWithoutSelected[i].name.match(
              new RegExp(splitToolQueryArray[j], 'i')
            );

            // if the split tool query doesn't match current option, jump over this query in the loop
            if (!isMatch) continue;

            // if the split tool query matches current option, push current option into list and jump out of this loop
            list.push(optionListWithoutSelected[i]);
            break;
          }
        }

        return list;
      }
    },

    isDisableSelect() {
      if (this.comparisonToolList.length >= 6) return true;
      return false;
    },
  },

  methods: {
    ...mapMutations(['updateComparisonToolList']),

    selectOption(val) {
      if (this.isDisableSelect) return;

      const newToolList = new Set([...this.comparisonToolList, val]);
      this.updateComparisonToolList([...newToolList]);
    },
  },

  mounted() {
    this.tools = TOOLS;
  },
};
</script>

<style scoped lang="scss">
.tool-option {
  position: relative;
  margin: 0.75rem;
  height: 3rem;
  width: calc(100% - 1.5rem);
  max-width: 400px;
  line-height: 3rem;
  background-color: white;
  font-size: 1rem;
  padding: 0 1rem;
}

span:nth-child(1) {
  display: inline-block;
  width: calc(100% - 4rem);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

span:nth-child(2) {
  position: absolute;
  right: 1rem;
  height: 3rem;
  width: 3rem;
  text-align: center;
  font-weight: 600;
  color: $text-light-blue;
}

.show-hover-effect:hover {
  cursor: pointer;
  text-decoration: underline;
}

.disable-select {
  opacity: 0.5;

  &:hover {
    cursor: not-allowed;
  }
}

.tooltip-add {
  display: none;
  font-size: 2rem;
}
</style>
